module.exports = __webpack_public_path__ + "static/img/al.60765067.svg";